import { createContext, useContext } from 'react';
import { noop } from '@synergy/utils';

interface SearchContextData {
    search: string;
    onUpdateSearch: (search: string) => void;
}

export const SearchContext = createContext<SearchContextData>({
    search: '',
    onUpdateSearch: noop,
});

export const useSearch = () => useContext(SearchContext);
